import {
    MARITAL_STATUS_LIST_REQUEST,
    MARITAL_STATUS_LIST_SUCCESS,
    MARITAL_STATUS_LIST_FAIL
} from '../constants/maritalStatusConstants'

export const maritalStatusListReducer = (state = {}, action) => {
    switch (action.type) {
        case MARITAL_STATUS_LIST_REQUEST:
            return { loading: true }
        case MARITAL_STATUS_LIST_SUCCESS:
            return { loading: false, maritalstatuss: action.payload }
        case MARITAL_STATUS_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

